<script lang="ts">
    import src from './svg/arrow-rules.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    export let title: string = '';

    let alt = title;
</script>

<div style="padding:7px 2px; display: flex; align-items: center;margin-right: 5px;">
    <img {src} {alt} style="width: 35px; height: 13px; opacity: 0.4;" />
</div>
